import { useNavigate, useParams } from "react-router-dom";
import ModalWindow from "../../../../components/ui/modal-window";
import { ActionsEnum } from "../../../../assets/utils/enums/settings";

export default function DeleteTeamUserModal() {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <ModalWindow
            isOpen
            action={ActionsEnum.DELETE}
            onConfirm={() => {
                console.log("delete member");
                navigate(-1); // повертаємось назад
            }}
            customText={`Видалення учасника команди під ID #${id}`}
            onCancel={() => navigate(-1)}
        />
    );
}